import Vue from 'vue'

let dropDown = new Vue({
  created () {
    this.$on('opend-dropdown', (open) => {
      let eles = document.getElementsByClassName('m-dropdown-content')
      for (let i = 0; i < eles.length; i++) {
        if (eles[i].id !== open) {
          eles[i].style.display = 'none'
        }
      }
    })

    document.addEventListener('click', (e) => {
      let parentDropdown = e.target.closest('.m-dropdown-content')
      if (!parentDropdown || parentDropdown.style.display !== 'block') {
        this.$emit('opend-dropdown', null)
      }
    })
  },

  methods: {
    switchDropDown (dropDownBody) {
      let display = document.getElementById(dropDownBody).style.display === 'block' ? 'none' : 'block'
      document.getElementById(dropDownBody).style.display = display

      if (display === 'block') {
        this.$emit('opend-dropdown', dropDownBody)
      }
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$dropDown = dropDown
  }
}
